(() => {
  const roots = document.querySelectorAll('[data-eza-bundle]');
  if (!roots.length) return;

  roots.forEach((root) => initBundle(root));

  function initBundle(root) {
    const pieceCount = Math.max(1, parseInt(root.dataset.pieceCount || '3', 10));
    const bundleVariantId = root.dataset.bundleVariantId || '';
    const bundlePrice = Math.max(0, parseInt(root.dataset.bundlePrice || '0', 10));
    const cartAddUrl = root.dataset.cartAddUrl || '/cart/add.js';
    const cartUrl = root.dataset.cartUrl || '/cart';
    const allowDuplicates = root.dataset.allowDuplicates !== 'false';
    const rootUrl = root.dataset.rootUrl || '/';

    const barSlotsEl = root.querySelector('[data-eza-bar-slots]');
    const tabs = [...root.querySelectorAll('[data-eza-tab]')];
    const panels = [...root.querySelectorAll('[data-eza-panel]')];
    const bar = root.querySelector('[data-eza-bar]');
    const progressEl = root.querySelector('[data-eza-progress]');
    const checkoutBtn = root.querySelector('[data-eza-checkout]');
    const errorEl = root.querySelector('[data-eza-error]');
    const scrollTriggers = root.querySelectorAll('[data-eza-scroll-builder]');
    const qv = root.querySelector('[data-eza-qv]');
    const barCompareEl = root.querySelector('[data-eza-bar-compare]');
    const barSaveEl = root.querySelector('[data-eza-bar-save]');

    const selected = Array.from({ length: pieceCount }, () => null);
    let activeSlot = 0;
    let qvProduct = null;

    renderBarSlots();
    bindSlotClicks(barSlotsEl);
    bindTabs();
    bindCards();
    bindCheckout();
    bindScroll();
    bindQuickView();
    bindFooterClearance();
    updateUI();

    function slotMarkup(i) {
      return `
        <div class="eza-bundle__slot eza-bundle__slot--bar" data-slot-index="${i}" role="button" tabindex="0" aria-label="Piece ${i + 1}">
          <button type="button" class="eza-bundle__slot-remove" data-eza-remove aria-label="Remove piece ${i + 1}" hidden>
            <span aria-hidden="true">×</span>
          </button>
          <div class="eza-bundle__slot-empty">
            <span class="eza-bundle__slot-label">Piece: ${i + 1}</span>
            <span class="eza-bundle__slot-plus" aria-hidden="true">+</span>
          </div>
          <div class="eza-bundle__slot-filled">
            <div class="eza-bundle__slot-media"><img alt=""></div>
            <p class="eza-bundle__slot-title"></p>
          </div>
        </div>
      `;
    }

    function renderBarSlots() {
      if (!barSlotsEl) return;
      barSlotsEl.style.setProperty('--eza-slots', String(pieceCount));
      barSlotsEl.innerHTML = '';
      for (let i = 0; i < pieceCount; i += 1) {
        barSlotsEl.insertAdjacentHTML('beforeend', slotMarkup(i));
      }
    }

    function bindSlotClicks(container) {
      if (!container) return;

      container.addEventListener('click', (event) => {
        const removeBtn = event.target.closest('[data-eza-remove]');
        const slot = event.target.closest('[data-slot-index]');
        if (!slot || !container.contains(slot)) return;
        const index = parseInt(slot.dataset.slotIndex, 10);

        if (removeBtn) {
          event.preventDefault();
          event.stopPropagation();
          selected[index] = null;
          activeSlot = index;
          updateUI();
          return;
        }

        activeSlot = index;
        updateUI();
      });

      container.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        const slot = event.target.closest('[data-slot-index]');
        if (!slot || event.target.closest('[data-eza-remove]')) return;
        event.preventDefault();
        activeSlot = parseInt(slot.dataset.slotIndex, 10);
        updateUI();
      });
    }

    function bindTabs() {
      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const id = tab.dataset.ezaTab;
          tabs.forEach((t) => t.classList.toggle('is-active', t === tab));
          panels.forEach((panel) => {
            panel.classList.toggle('is-active', panel.dataset.ezaPanel === id);
          });
        });
      });
    }

    function getVariantPriceCents(card, variantId) {
      const select = card.querySelector('[data-eza-variant]');
      if (select) {
        const option = [...select.options].find((opt) => String(opt.value) === String(variantId));
        if (option && option.dataset.price) {
          return Math.max(0, parseInt(option.dataset.price, 10) || 0);
        }
      }
      return Math.max(0, parseInt(card.dataset.price || '0', 10) || 0);
    }

    function selectedPiecesTotal() {
      return selected.reduce((sum, item) => sum + (item && item.priceCents ? item.priceCents : 0), 0);
    }

    function addItemFromCard(card, variantIdOverride) {
      if (card.classList.contains('is-soldout')) return false;
      const select = card.querySelector('[data-eza-variant]');
      const variantId = variantIdOverride || (select ? select.value : card.dataset.variantId);
      if (!variantId) {
        showError('Please select an option.');
        return false;
      }

      const optionLabel = select
        ? select.options[select.selectedIndex]?.textContent?.trim()
        : '';

      // If QV passed a different variant, resolve its option label from card select when possible
      let resolvedOption = optionLabel;
      if (variantIdOverride && select) {
        const match = [...select.options].find((opt) => String(opt.value) === String(variantId));
        const text = match?.textContent?.trim() || '';
        resolvedOption = text && text !== 'Default Title' ? text.replace(/\s—\sSold out$/, '') : '';
      } else if (resolvedOption === 'Default Title') {
        resolvedOption = '';
      }

      const item = {
        variantId: String(variantId),
        productId: card.dataset.productId || '',
        title: card.dataset.title || '',
        option: resolvedOption && resolvedOption !== 'Default Title' ? resolvedOption : '',
        image: card.dataset.image || '',
        handle: card.dataset.handle || '',
        priceCents: getVariantPriceCents(card, variantId),
      };

      if (!allowDuplicates && selected.some((s) => s && s.variantId === item.variantId)) {
        showError('This piece is already in your set. Pick another.');
        return false;
      }

      const filledCount = selected.filter(Boolean).length;
      if (filledCount >= pieceCount && selected[activeSlot] == null) {
        showError(`You can only pick ${pieceCount} pieces per bundle.`);
        return false;
      }

      let target = activeSlot;
      if (selected[target] != null) {
        const firstEmpty = selected.findIndex((s) => s == null);
        target = firstEmpty === -1 ? activeSlot : firstEmpty;
      }

      selected[target] = item;
      const nextEmpty = selected.findIndex((s) => s == null);
      activeSlot = nextEmpty === -1 ? target : nextEmpty;
      clearError();
      updateUI();
      return true;
    }

    function bindCards() {
      root.querySelectorAll('[data-eza-card]').forEach((card) => {
        const select = card.querySelector('[data-eza-variant]');
        const addBtn = card.querySelector('[data-eza-add]');
        if (select) {
          select.addEventListener('change', () => {
            card.dataset.variantId = select.value;
            const opt = select.options[select.selectedIndex];
            if (opt?.dataset.price) card.dataset.price = opt.dataset.price;
          });
        }
        if (addBtn) {
          addBtn.addEventListener('click', () => addItemFromCard(card));
        }
      });
    }

    function bindQuickView() {
      if (!qv) return;

      const imageEl = qv.querySelector('[data-eza-qv-image]');
      const thumbsEl = qv.querySelector('[data-eza-qv-thumbs]');
      const titleEl = qv.querySelector('[data-eza-qv-title]');
      const priceEl = qv.querySelector('[data-eza-qv-price]');
      const descEl = qv.querySelector('[data-eza-qv-desc]');
      const ratingEl = qv.querySelector('[data-eza-qv-rating]');
      const variantEl = qv.querySelector('[data-eza-qv-variant]');
      const addEl = qv.querySelector('[data-eza-qv-add]');
      const linkEl = qv.querySelector('[data-eza-qv-link]');
      const counterEl = qv.querySelector('[data-eza-qv-counter]');
      const prevBtn = qv.querySelector('[data-eza-qv-prev]');
      const nextBtn = qv.querySelector('[data-eza-qv-next]');

      let gallery = [];
      let galleryIndex = 0;

      root.addEventListener('click', async (event) => {
        const btn = event.target.closest('[data-eza-quickview]');
        if (!btn) return;
        const card = btn.closest('[data-eza-card]');
        if (!card) return;
        event.preventDefault();
        event.stopPropagation();
        await openQuickView(card);
      });

      qv.querySelectorAll('[data-eza-qv-close]').forEach((el) => {
        el.addEventListener('click', closeQuickView);
      });

      document.addEventListener('keydown', (event) => {
        if (qv.hasAttribute('hidden')) return;
        if (event.key === 'Escape') closeQuickView();
        if (event.key === 'ArrowLeft') showImage(galleryIndex - 1);
        if (event.key === 'ArrowRight') showImage(galleryIndex + 1);
      });

      if (thumbsEl) {
        thumbsEl.addEventListener('click', (event) => {
          const thumb = event.target.closest('[data-index]');
          if (!thumb) return;
          showImage(parseInt(thumb.dataset.index, 10));
        });
      }

      if (prevBtn) prevBtn.addEventListener('click', () => showImage(galleryIndex - 1));
      if (nextBtn) nextBtn.addEventListener('click', () => showImage(galleryIndex + 1));

      if (addEl) {
        addEl.addEventListener('click', () => {
          if (!qvProduct?.card) return;
          const card = qvProduct.card;
          const variantId = variantEl && !variantEl.hidden ? variantEl.value : card.dataset.variantId;
          if (variantEl && !variantEl.hidden) {
            const opt = variantEl.options[variantEl.selectedIndex];
            card.dataset.variantId = variantId;
            if (opt?.dataset.price) card.dataset.price = opt.dataset.price;
            const cardSelect = card.querySelector('[data-eza-variant]');
            if (cardSelect) {
              cardSelect.value = variantId;
              if (opt?.dataset.price) {
                const cardOpt = [...cardSelect.options].find((o) => String(o.value) === String(variantId));
                if (cardOpt) cardOpt.dataset.price = opt.dataset.price;
              }
            }
          }
          const ok = addItemFromCard(card, variantId);
          if (ok) closeQuickView();
        });
      }

      function normalizeUrl(src) {
        if (!src) return '';
        if (src.startsWith('//')) return `https:${src}`;
        return src;
      }

      function parseCardImages(card) {
        try {
          const raw = card.getAttribute('data-images') || '[]';
          const parsed = JSON.parse(raw);
          if (Array.isArray(parsed) && parsed.length) {
            return parsed.map(normalizeUrl).filter(Boolean);
          }
        } catch (e) {
          /* ignore */
        }
        return card.dataset.image ? [normalizeUrl(card.dataset.image)] : [];
      }

      function showImage(index) {
        if (!gallery.length || !imageEl) return;
        galleryIndex = (index + gallery.length) % gallery.length;
        imageEl.src = gallery[galleryIndex];
        if (counterEl) {
          counterEl.textContent = `${galleryIndex + 1} / ${gallery.length}`;
          counterEl.hidden = gallery.length < 2;
        }
        if (prevBtn) prevBtn.hidden = gallery.length < 2;
        if (nextBtn) nextBtn.hidden = gallery.length < 2;
        if (thumbsEl) {
          thumbsEl.querySelectorAll('button').forEach((b, i) => {
            b.classList.toggle('is-active', i === galleryIndex);
          });
          const active = thumbsEl.querySelector('.is-active');
          if (active) active.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      }

      function renderThumbs() {
        if (!thumbsEl) return;
        if (gallery.length < 2) {
          thumbsEl.innerHTML = '';
          thumbsEl.hidden = true;
          return;
        }
        thumbsEl.hidden = false;
        thumbsEl.innerHTML = gallery
          .map(
            (url, index) =>
              `<button type="button" class="${index === 0 ? 'is-active' : ''}" data-index="${index}" aria-label="Image ${index + 1}">
                <img src="${url}" alt="">
              </button>`
          )
          .join('');
      }

      async function openQuickView(card) {
        const handle = card.dataset.handle;
        if (!handle) return;

        gallery = parseCardImages(card);
        galleryIndex = 0;
        qvProduct = { card };

        titleEl.textContent = card.dataset.title || '';
        priceEl.textContent = '';
        const localDesc = card.querySelector('.eza-bundle__card-desc');
        descEl.innerHTML = localDesc ? localDesc.innerHTML : '<p>Loading details…</p>';
        ratingEl.innerHTML = `<div class="custom-vstar-rating-widget" data-product-id="${card.dataset.productId}"></div>`;
        variantEl.hidden = true;
        variantEl.innerHTML = '';

        if (linkEl) {
          linkEl.href = card.dataset.productUrl || `${rootUrl.replace(/\/?$/, '/')}products/${handle}`;
        }

        // Sync variant selector from card
        const cardSelect = card.querySelector('[data-eza-variant]');
        if (cardSelect && cardSelect.options.length > 1) {
          variantEl.hidden = false;
          variantEl.innerHTML = cardSelect.innerHTML;
          variantEl.value = cardSelect.value;
        }

        renderThumbs();
        showImage(0);
        qv.hidden = false;
        document.documentElement.classList.add('eza-bundle-qv-open');

        try {
          const base = rootUrl.endsWith('/') ? rootUrl : `${rootUrl}/`;
          const productUrl = `${base}products/${handle}.js`;
          const response = await fetch(productUrl);
          if (!response.ok) throw new Error('Could not load product');
          const product = await response.json();
          qvProduct.product = product;

          titleEl.textContent = product.title || card.dataset.title || '';

          const priceHtml = [];
          if (product.compare_at_price && product.compare_at_price > product.price) {
            priceHtml.push(`<s>${formatMoney(product.compare_at_price)}</s> `);
          }
          priceHtml.push(formatMoney(product.price));
          priceEl.innerHTML = priceHtml.join('');

          if (product.description) {
            descEl.innerHTML = product.description;
          }

          const fetchedImages = (product.images || [])
            .map((src) => normalizeUrl(typeof src === 'string' ? src : src?.src || ''))
            .filter(Boolean);
          if (fetchedImages.length > gallery.length) {
            gallery = fetchedImages;
            renderThumbs();
            showImage(0);
          }

          const variants = product.variants || [];
          if (variants.length > 1) {
            variantEl.hidden = false;
            variantEl.innerHTML = variants
              .map((v) => {
                const disabled = v.available === false ? 'disabled' : '';
                const selectedAttr = String(v.id) === String(card.dataset.variantId) ? 'selected' : '';
                return `<option value="${v.id}" data-price="${v.price}" ${disabled} ${selectedAttr}>${v.title}${
                  v.available === false ? ' — Sold out' : ''
                }</option>`;
              })
              .join('');

            // Keep card select prices in sync for add-to-bundle
            const cardSelect = card.querySelector('[data-eza-variant]');
            if (cardSelect && variants.length > 1) {
              cardSelect.innerHTML = variantEl.innerHTML;
            }
          }

          if (window.Trustoo && typeof window.Trustoo.init === 'function') {
            window.Trustoo.init();
          }
        } catch (err) {
          if (!descEl.innerHTML || descEl.textContent.includes('Loading')) {
            descEl.innerHTML = `<p>${err.message || 'Unable to load extra details.'}</p>`;
          }
        }
      }

      function closeQuickView() {
        qv.hidden = true;
        document.documentElement.classList.remove('eza-bundle-qv-open');
        qvProduct = null;
        gallery = [];
        galleryIndex = 0;
      }
    }

    function formatMoney(cents) {
      try {
        const amount = (Number(cents) / 100).toFixed(2);
        return `£${amount}`;
      } catch (e) {
        return '';
      }
    }

    function bindCheckout() {
      if (!checkoutBtn) return;
      checkoutBtn.addEventListener('click', async () => {
        if (selected.filter(Boolean).length < pieceCount) {
          showError(`Please select all ${pieceCount} pieces.`);
          return;
        }
        if (!bundleVariantId) {
          showError('Bundle product is not configured. Add a Bundle product in the theme editor.');
          return;
        }

        checkoutBtn.disabled = true;
        checkoutBtn.classList.add('is-loading');
        clearError();

        const properties = {
          '_Bundle type': 'any-n',
          '_Bundle count': String(pieceCount),
        };

        const piecesTotal = selectedPiecesTotal();
        if (piecesTotal > 0) {
          properties['Bought separately'] = formatMoney(piecesTotal);
          if (bundlePrice > 0 && piecesTotal > bundlePrice) {
            properties['You save'] = formatMoney(piecesTotal - bundlePrice);
          }
          properties['_Pieces value'] = String(piecesTotal);
        }

        const pieceVariantIds = [];
        selected.forEach((item, index) => {
          if (!item) return;
          const n = index + 1;
          const label = item.option ? `${item.title} — ${item.option}` : item.title;
          properties[`Piece ${n}`] = label;
          properties[`_Piece ${n} variant`] = item.variantId;
          properties[`_Piece ${n} handle`] = item.handle;
          pieceVariantIds.push(item.variantId);
          if (item.image) {
            properties[`_Piece ${n} image`] = item.image;
          }
          if (item.priceCents) {
            properties[`_Piece ${n} price`] = String(item.priceCents);
          }
        });
        if (pieceVariantIds.length) {
          properties['_Piece variants'] = pieceVariantIds.join(',');
        }

        const payload = {
          items: [
            {
              id: Number(bundleVariantId),
              quantity: 1,
              properties,
            },
          ],
        };

        try {
          const response = await fetch(cartAddUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify(payload),
          });
          const data = await response.json();
          if (!response.ok || data.status) {
            throw new Error(data.description || data.message || 'Could not add bundle to cart.');
          }

          // Reset selection so customer can build another bundle after returning
          selected.fill(null);
          activeSlot = 0;
          updateUI();
          window.location.href = cartUrl;
        } catch (err) {
          showError(err.message || 'Something went wrong. Please try again.');
          checkoutBtn.disabled = false;
          checkoutBtn.classList.remove('is-loading');
        }
      });
    }

    function bindFooterClearance() {
      if (!bar) return;

      const footerSelectors = [
        '.site-footer-wrapper',
        '.shopify-section-group-group-footer',
        '#shopify-section-footer',
        'footer.site-footer-wrapper',
        'footer',
      ];

      function getFooter() {
        for (const selector of footerSelectors) {
          const el = document.querySelector(selector);
          if (el) return el;
        }
        return null;
      }

      let ticking = false;

      function sync() {
        ticking = false;
        const footer = getFooter();
        if (!footer) {
          bar.style.bottom = '';
          bar.classList.remove('is-above-footer');
          return;
        }

        const footerTop = footer.getBoundingClientRect().top;
        const overlap = Math.max(0, window.innerHeight - footerTop);

        if (overlap > 0) {
          bar.style.bottom = `${overlap}px`;
          bar.classList.add('is-above-footer');
        } else {
          bar.style.bottom = '';
          bar.classList.remove('is-above-footer');
        }
      }

      function onScrollOrResize() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(sync);
      }

      window.addEventListener('scroll', onScrollOrResize, { passive: true });
      window.addEventListener('resize', onScrollOrResize);
      sync();
    }

    function bindScroll() {
      scrollTriggers.forEach((el) => {
        el.addEventListener('click', (event) => {
          event.preventDefault();
          const builder = root.querySelector('#eza-bundle-builder');
          if (builder) builder.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });
    }

    function syncSlotNode(slot, index) {
      const item = selected[index];
      slot.classList.toggle('is-active', index === activeSlot);
      slot.classList.toggle('is-filled', Boolean(item));

      const removeBtn = slot.querySelector('[data-eza-remove]');
      if (removeBtn) removeBtn.hidden = !item;

      if (item) {
        const img = slot.querySelector('.eza-bundle__slot-media img');
        const title = slot.querySelector('.eza-bundle__slot-title');
        if (img) {
          img.src = item.image;
          img.alt = item.title;
        }
        if (title) {
          title.textContent = item.option ? `${item.title} (${item.option})` : item.title;
        }
      }
    }

    function updateUI() {
      if (barSlotsEl) {
        barSlotsEl.querySelectorAll('[data-slot-index]').forEach((slot) => {
          syncSlotNode(slot, parseInt(slot.dataset.slotIndex, 10));
        });
      }

      const count = selected.filter(Boolean).length;
      const piecesTotal = selectedPiecesTotal();
      if (progressEl) {
        progressEl.innerHTML = `You've selected <strong>${count}</strong> out of your <strong>${pieceCount}</strong> pieces.`;
      }

      if (barCompareEl) {
        if (piecesTotal > 0 && (bundlePrice === 0 || piecesTotal > bundlePrice)) {
          barCompareEl.hidden = false;
          barCompareEl.textContent = formatMoney(piecesTotal);
        } else {
          barCompareEl.hidden = true;
          barCompareEl.textContent = '';
        }
      }

      if (barSaveEl) {
        const saveAmount = piecesTotal - bundlePrice;
        if (piecesTotal > 0 && bundlePrice > 0 && saveAmount > 0) {
          barSaveEl.hidden = false;
          barSaveEl.textContent = `Save ${formatMoney(saveAmount)}`;
        } else {
          barSaveEl.hidden = true;
          barSaveEl.textContent = '';
        }
      }

      if (bar) bar.classList.add('is-visible');
      if (checkoutBtn) {
        const ready = count === pieceCount && Boolean(bundleVariantId);
        checkoutBtn.disabled = !ready;
        checkoutBtn.classList.toggle('is-disabled', !ready);
      }
    }

    function showError(message) {
      if (errorEl) errorEl.textContent = message;
    }

    function clearError() {
      if (errorEl) errorEl.textContent = '';
    }
  }
})();
